/**
 * HTML de la pestaña Incentivos del modal de contratos — funciones PURAS.
 *
 * Viven fuera de `contrato-modal.js` para que `node --test` las importe sin
 * arrastrar `App` ni el DOM: son la MISMA autoridad que pinta el modal, así
 * que la prueba mira el HTML real y no una réplica.
 *
 * Todo dato que llega de la API (nombre, trigger, descripción, categoría) lo
 * escribió un humano con permiso de Marketing: se escapa SIEMPRE antes de
 * interpolarlo (P2-3 de la auditoría de Marketing Brasil 2026-09-09: XSS
 * persistente entre administradores).
 */
import { escapeHtml } from '@shared/utils/escape-html.js';
import { t } from '../services/i18n-admin.js';

const LARGO_MAXIMO_DE_DESCRIPCION_EN_TARJETA = 60;

/** Fila de una promoción scoped al nodo del contrato, con sus acciones. */
export function htmlDeIncentivoScoped(promocion) {
    const nombre = escapeHtml(promocion.nombre || '');
    const estadoBadge = promocion.activo
        ? `<span class="badge" style="background:rgba(34,197,94,0.15); color:var(--accent-green);">${t('Activo')}</span>`
        : `<span class="badge" style="background:rgba(255,255,255,0.1); color:var(--text-tertiary);">${t('Inactivo')}</span>`;
    return `
        <div style="padding:10px 12px; background:var(--bg-tertiary); border-radius:6px; border:1px solid var(--border-glass);">
            <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:4px;">
                <strong style="font-size:13px;">${nombre}</strong>
                <div style="display:flex; align-items:center; gap:6px;">
                    ${estadoBadge}
                    <button class="btn btn-sm" style="font-size:10px; padding:2px 6px; background:rgba(59,130,246,0.15); color:var(--accent-blue); border:1px solid rgba(59,130,246,0.3);"
                        data-action="contrato:editarPromoScoped" data-id="${Number(promocion.id)}">${t('Editar')}</button>
                    <button class="btn btn-sm" style="font-size:10px; padding:2px 6px; background:rgba(239,68,68,0.15); color:var(--accent-red); border:1px solid rgba(239,68,68,0.3);"
                        data-action="contrato:eliminarPromoScoped" data-id="${Number(promocion.id)}" data-nombre="${nombre}">${t('Eliminar')}</button>
                </div>
            </div>
            <div style="font-size:12px; color:var(--text-secondary);">
                ${t('Trigger')}: <span class="badge" style="background:rgba(59,130,246,0.15); color:var(--accent-blue);">${escapeHtml(promocion.trigger_evento || '')}</span>
            </div>
        </div>`;
}

/** Cabecera de un grupo de plantillas por categoría. */
export function htmlDeCabeceraDeCategoria(categoria) {
    return `<div style="font-size:11px; text-transform:uppercase; color:var(--text-tertiary); margin-bottom:4px; font-weight:600;">${escapeHtml(categoria)}</div>`;
}

/** Tarjeta clicable de un preset clonable al nodo del contrato. */
export function htmlDeTarjetaDePresetClonable(preset) {
    const nombre = escapeHtml(preset.nombre || '');
    const descripcion = preset.descripcion
        ? `<span style="margin-left:4px;">${escapeHtml(preset.descripcion.substring(0, LARGO_MAXIMO_DE_DESCRIPCION_EN_TARJETA))}</span>`
        : '';
    return `
        <div style="padding:8px 10px; background:var(--bg-tertiary); border-radius:6px; border:1px solid var(--border-glass); margin-bottom:4px; display:flex; justify-content:space-between; align-items:center; cursor:pointer;"
             data-action="contrato:clonarPresetScoped" data-id="${Number(preset.id)}" data-nombre="${nombre}">
            <div>
                <div style="font-size:13px; font-weight:600;">${nombre}</div>
                <div style="font-size:11px; color:var(--text-secondary);">
                    <span class="badge" style="background:rgba(59,130,246,0.15); color:var(--accent-blue); font-size:10px;">${escapeHtml(preset.trigger_evento || '')}</span>
                    ${descripcion}
                </div>
            </div>
            <span class="btn btn-sm" style="font-size:11px; padding:4px 10px; background:var(--accent-green); color:#fff; pointer-events:none;">${t('Activar')}</span>
        </div>`;
}
